import {Link, useLocation} from 'react-router-dom';
import React, {useContext, useState} from 'react';
import EventEmitter from '../utils/emmiter';
import {UserContext} from '../utils/usercontext';
import AudioPlayer from './components/audio/audioplayer';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './css/header.css';

export default function Header() {

	const [metaHyper, setMetaHyper] = useState({connected: 0, dj: '', artist: '', title: '', art: '', time: 0, listeners: 0});
	const [metaEvolution, setMetaEvolution] = useState({connected: 0, dj: '', artist: '', title: '', art: '', time: 0, listeners: 0});
	
	const {user} = useContext(UserContext);
	const [page, setPage] = useState('index');
	const [subPage, setSubPage] = useState('');
	const [mobile, setmobile] = useState(false);
	const [index, setIndex] = useState(-1);

	

	let location = useLocation();
	React.useEffect(() => {

		EventEmitter.addListener('/channel/meta', async data => {
			switch(data.channel) {
				case 'hyper':
					setMetaHyper(data.azura);
				break;
				case 'evolution':
					setMetaEvolution(data.azura);
				break;
			}
		});

		switch(true) {
			case /^\/radio\/house/.test(location.pathname):

			  setPage('radio'); setSubPage('house');

			  break;

			case /^\/radio\/trance/.test(location.pathname):

			  setPage('radio'); setSubPage('trance');

			  break;

			case /^\/radio\/techno/.test(location.pathname):

			  setPage('radio'); setSubPage('techno');

			  break;

			case /^\/radio\/oldskool/.test(location.pathname):

			  setPage('radio'); setSubPage('oldskool');

			  break;


			case /^\/about/.test(location.pathname):
				setPage('mix365'); setSubPage('about');
				break;
			case /^\/privacy/.test(location.pathname):

				  setPage('mix365'); setSubPage('privacy');

				  break;

			case /^\/events/.test(location.pathname):
				setPage('mix365'); setSubPage('events');
				break;
			case /^\/mix365djs/.test(location.pathname):
				setPage('mix365'); setSubPage('mix365djs');
				break;
			case /^\/previous-sets/.test(location.pathname):
				setPage('mix365'); setSubPage('previous-sets');
				break;
			case /^\/listen/.test(location.pathname):
				setPage('mix365'); setSubPage('listen');
				break;
			
			case /^\/schedule/.test(location.pathname):
				setPage('schedule'); setSubPage('');
				break;

			case /^\/hyper\/schedule/.test(location.pathname):
				setPage('schedule'); setSubPage('hyper/schedule');
				break;
			case /^\/hyper/.test(location.pathname):
				setPage('chatlive'); setSubPage('hyper');
				break;
			case /^\/evolution\/schedule/.test(location.pathname):
				setPage('schedule'); setSubPage('evolution/schedule');
				break;
			case /^\/evolution/.test(location.pathname):
				setPage('chatlive'); setSubPage('evolution');
				break;

			case /^\/contact/.test(location.pathname):
				setPage('contact'); setSubPage('contact');
				break;
			case /^\/apply/.test(location.pathname):
				setPage('contact'); setSubPage('apply');
				break;
			case /^\/advertise/.test(location.pathname):
				setPage('contact'); setSubPage('advertise');
				break;

			case /^\/shop/.test(location.pathname):
				setPage('shop'); setSubPage('');
				break;

			case /^\/login/.test(location.pathname):
				setPage('login'); setSubPage('');
				break;

			case /^\/register/.test(location.pathname):
				setPage('register'); setSubPage('');
				break;

			case /^\/djarea$/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea');
				break;
			case /^\/djarea\/members/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/members');
				break;
			case /^\/djarea\/connection/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/connection');
				break;
			case /^\/djarea\/socials/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/socials');
				break;
			case /^\/djarea\/posters/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/posters');
				break;
			case /^\/djarea\/files/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/files');
				break;
			case /^\/djarea\/logs/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/logs');
				break;


			case /^\/admin$/.test(location.pathname):
				setPage('admin'); setSubPage('admin');
				break;
			case /^\/admin\/djaccounts/.test(location.pathname):
				setPage('admin'); setSubPage('admin/djaccounts');
				break;
			case /^\/admin\/events/.test(location.pathname):
				setPage('admin'); setSubPage('admin/events');
				break;
			case /^\/admin\/weekly/.test(location.pathname):
				setPage('admin'); setSubPage('admin/weekly');
				break;
			case /^\/admin\/publish/.test(location.pathname):
				setPage('admin'); setSubPage('admin/publish');
				break;
			case /^\/admin\/seo/.test(location.pathname):
				setPage('admin'); setSubPage('admin/seo');
				break;

			default:
				setPage('index'); setSubPage('');
				break;
		}
  }, [location]);
	
	function mobileMenu() {
		setmobile(!mobile);
	}

	function setMenu(value) {
		if( index === value ) {
			setIndex(-1);
		} else {
			setIndex(value);
		}
	}

	function playRadio(channel) {
		EventEmitter.emit('/audio/controller', {play: true, channel});
	}

	function donation() {
		EventEmitter.emit('/donation/donate', {uid: 0});
	}
	
	return (
		<>
			{user?.user &&
				<header className="header">
					<div className="d-none d-md-block">
						<Row className="header-inner py-3">
							<Col xs md={2} className="header-logo">
								<Link to="/">
									<img className="logo-365" src="/images/365_Logo-4.png" alt="Mix365 Logo" />
								</Link>
							</Col>
							<Col className="text-vertical">
								<div>
								<ul className="header-menu">
									<li><Link to="/" className={page==='index'?"header-menu-active":""}>HOME</Link></li>
									<li><Link to="/about" className={page==='mix365'?"header-menu-active":""}>ABOUT US</Link>

								  <ul className="header-dropdown">

								    <li className={subPage==='about'?"header-dropdown-active":""}><Link to="/about"><FontAwesomeIcon icon={['far', 'address-card']} />&nbsp;&nbsp;ABOUT US</Link></li>

								    <li className={subPage==='mix365djs'?"header-dropdown-active":""}><Link to="/mix365djs"><FontAwesomeIcon icon="user-group" />&nbsp;&nbsp;MIX365 DJ'S</Link></li>

								    <li className={subPage==='previous-sets'?"header-dropdown-active":""}><Link to="/previous-sets"><FontAwesomeIcon icon="headphones" />&nbsp;&nbsp;PREVIOUS SETS</Link></li>

								    <li className={subPage==='listen'?"header-dropdown-active":""}><Link to="/listen"><FontAwesomeIcon icon="volume-high" />&nbsp;&nbsp;WAYS TO LISTEN</Link></li>

								    <li className={subPage==='privacy' ? "header-dropdown-active" : ""}><Link to="/privacy"><FontAwesomeIcon icon="lock" />&nbsp;&nbsp;PRIVACY POLICY</Link></li>

								  </ul>

								</li>



								

								


									<li><Link to="/schedule" className={page==='schedule'?"header-menu-active":""}>SCHEDULE</Link>
										<ul className="header-dropdown">
											<li className={subPage==='hyper/schedule'?"header-dropdown-active":""}><Link to="/hyper/schedule"><FontAwesomeIcon icon={['far', 'calendar']} />&nbsp;&nbsp;MIX365 HYPER</Link></li>
											<li className={subPage==='evolution/schedule'?"header-dropdown-active":""}><Link to="/evolution/schedule"><FontAwesomeIcon icon={['far', 'calendar']} />&nbsp;&nbsp;MIX365 EVOLUTION</Link></li>
										</ul>
									</li>
									<li><Link to="/hyper" className={page==='chatlive'?"header-menu-active":""}>Watch LIVE</Link>
										<ul className="header-dropdown-live">
											<li>
												<Link to="/hyper">
													<Row className="header-dropdown-bottom gx-0" style={{padding: '0px 18px'}}>
														<Col xs={12} className="header-user">
															<img src='/images/channel_hyper0.png' width="100%" alt="Hyper Live" />
														</Col>
														<Col xs={12} className="text-center">
															{metaHyper.dj !== '' ?
																<>
																	<FontAwesomeIcon icon="tv" /> <span className="audioplayer-live" style={{color: '#ffffff'}}>Live</span> {metaHyper.dj}
																</>
															:
																<><FontAwesomeIcon icon="music" /> {String(`${metaHyper.artist} - ${metaHyper.title}`).substring(0, 30)}</>
															}
														</Col>
													</Row>
												</Link>
											</li>
											<li>
												<Link to="/evolution">
													<Row className="gx-0" style={{padding: '0px 18px'}}>
														<Col xs={12} className="header-user">
																<img src='/images/channel_evolution0.png' width="100%" alt="Evolution Live" />
														</Col>
														<Col xs={12} className="text-center">
															{metaEvolution.dj !== '' ?
																<>
																	<FontAwesomeIcon icon="tv" /> <span className="audioplayer-live" style={{color: '#ffffff'}}>Live</span> {metaEvolution.dj}
																</>
															:
																<><FontAwesomeIcon icon="music" /> {String(`${metaEvolution.artist} - ${metaEvolution.title}`).substring(0, 30)}</>
															}
														</Col>
													</Row>
												</Link>
											</li>
										</ul>
									</li>

<li><Link to="/radio" className={page==='radio' ? "header-menu-active" : ""}>RADIO</Link>

								  <ul className="header-dropdown">

								    <li className={subPage==='house' ? "header-dropdown-active" : ""}>

								      <Link to="/radio/house"><FontAwesomeIcon icon="music" />&nbsp;&nbsp;HOUSE</Link>

								    </li>

								    <li className={subPage==='trance' ? "header-dropdown-active" : ""}>

								      <Link to="/radio/trance"><FontAwesomeIcon icon="record-vinyl" />&nbsp;&nbsp;TRANCE</Link>

								    </li>

								    <li className={subPage==='techno' ? "header-dropdown-active" : ""}>

								      <Link to="/radio/techno"><FontAwesomeIcon icon="headphones" />&nbsp;&nbsp;TECHNO</Link>

								    </li>

								    <li className={subPage==='oldskool' ? "header-dropdown-active" : ""}>

								      <Link to="/radio/oldskool"><FontAwesomeIcon icon="compact-disc" />&nbsp;&nbsp;OLD SKOOL</Link>

								    </li>

								  </ul>

								</li>

									<li><Link to='/contact' className={page==='contact'?"header-menu-active":""}>CONTACT</Link>
										<ul className="header-dropdown">
											<li><Link to="/contact" className={subPage==='contact'?"header-menu-active":""}><FontAwesomeIcon icon={['far', 'address-card']} />&nbsp;&nbsp;CONTACT US</Link></li>
											<li><Link to="/apply" className={subPage==='apply'?"header-menu-active":""}><FontAwesomeIcon icon={['far', 'clipboard']} />&nbsp;&nbsp;APPLY TO DJ</Link></li>
											<li><Link to="/advertise" className={subPage==='advertise'?"header-menu-active":""}><FontAwesomeIcon icon="rectangle-ad" />&nbsp;&nbsp;ADVERTISE</Link></li>
										</ul>
									</li>
									<li><Link to="/shop" className={page==='shop'?"header-menu-active":""}>SHOP</Link></li>
								</ul>
								<AudioPlayer mobile={false} />
								</div>
							</Col>
							<Col lg={12} xl={3} className="text-vright">
								{user.access.level===1 ?
									<Row>
										<Col>
											<ul className="header-menu float-right">
												<li><Link to="#" onClick={()=>donation()}>DONATE</Link></li>
												<li><Link to="/login" className={page==='login'?"header-menu-active":""}>LOGIN</Link></li>
												<li><Link to="/register" className={page==='register'?"header-menu-active":""}>REGISTER</Link></li>
											</ul>
										</Col>
									</Row>
								:
									<Row>
										<Col>
											<ul className="header-menu float-right">
												<li><Link to="#" onClick={()=>donation()}>DONATE</Link></li>
												{/*<li><Link to="/">N</Link></li>*/}
												{user.admin?.mod_access &&
													<li><Link to="/djarea" className={page==='djarea'?"header-menu-active":""}>DJ AREA</Link>
														<div className="header-dropdown-live" style={{width: 450}}>
															<Row className="header-dropdown-bottom gx-0">
																<Col xs={12}><div className="djarea-title p-3">DJ AREA</div></Col>
																<Col xs={4} className="djarea-link"><Link to="/djarea/"><FontAwesomeIcon icon="house-user" /><br />DJ Area</Link></Col>
																
																<Col xs={4} className="djarea-link"><Link to="/djarea/connection"><FontAwesomeIcon icon="screwdriver-wrench" /><br />Connection</Link></Col>
																<Col xs={4} className="djarea-link"><Link to="/djarea/test"><FontAwesomeIcon icon="tv" /><br />Test Center</Link></Col>

																<Col xs={4} className="djarea-link"><Link to="/djarea/competition"><FontAwesomeIcon icon="trophy" /><br />Competition</Link></Col>
																<Col xs={4} className="djarea-link"><Link to="/djarea/members"><FontAwesomeIcon icon="user-group" /><br />Members</Link></Col>
																

																<Col xs={4} className="djarea-link"><Link to="/djarea/socials"><FontAwesomeIcon icon={['fab', 'facebook']} /><br />Socials</Link></Col>
																<Col xs={4} className="djarea-link"><Link to="/djarea/statistics"><FontAwesomeIcon icon="chart-line" /><br />Statistics</Link></Col>
																<Col xs={4} className="djarea-link"><Link to="/djarea/logs"><FontAwesomeIcon icon="calendar-days" /><br />Logs</Link></Col>
															</Row>
															{user.admin?.admin_access &&
																<Row className="gx-0">
																	<Col xs={12}><div className="djarea-title p-3">Admin</div></Col>
																	<Col xs={4} className="djarea-link"><Link to="/admin"><FontAwesomeIcon icon="house-user" /><br />Admin Area</Link></Col>
																	<Col xs={4} className="djarea-link"><Link to="/admin/djaccounts"><FontAwesomeIcon icon="user-group" /><br />DJ Accounts</Link></Col>
																	<Col xs={4} className="djarea-link"><Link to="/admin/events"><FontAwesomeIcon icon={['far', 'calendar']} /><br />Events</Link></Col>
																	<Col xs={4} className="djarea-link"><Link to="/admin/weekly"><FontAwesomeIcon icon="headphones" /><br />Weekly Sets</Link></Col>
																	<Col xs={4} className="djarea-link"><Link to="/admin/publish"><FontAwesomeIcon icon="headphones" /><br />Previous Sets</Link></Col>
																	<Col xs={4} className="djarea-link"><Link to="/admin/seo"><FontAwesomeIcon icon="magnifying-glass" /><br />SEO</Link></Col>
																</Row>
															}
														</div>
													</li>
												}
												{/*<li><Link to={`/notifications`} style={{position: 'relative'}}><FontAwesomeIcon icon="bell" className="notification-bell" /> <div className="notification-bell-number text-vcenter"><span>1</span></div></Link>

													{/*<li><Link to={`/notifications`}><FontAwesomeIcon icon="bell" />&nbsp;&nbsp;Notifications</Link></li>
												</li>*/}
												<li><Link to={`/${user.user.username.toLowerCase()}`}><img src={`https://mix365.co.uk${user.user.avatar}`} className="header-profile-image" alt="Profile Avatar" /> <FontAwesomeIcon icon="caret-down" />{/*user.user.title?user.user.title:user.user.username*/}</Link>
													<ul className="header-dropdown header-dropdown-profile">
														<li className="text-center p-3">{user.user.title?user.user.title:user.user.username}</li>
														<li><Link to={`/${user.user.username.toLowerCase()}`}><FontAwesomeIcon icon="user" />&nbsp;&nbsp;MY PROFILE</Link></li>
														<li><Link to={`/settings/${user.user.username.toLowerCase()}`}><FontAwesomeIcon icon="lock" />&nbsp;&nbsp;ACCOUNT SETTINGS</Link></li>
														<li><Link to="/logout"><FontAwesomeIcon icon="right-from-bracket" />&nbsp;&nbsp;LOG OUT</Link></li>
													</ul>
												</li>
											</ul>
										</Col>
									</Row>
								}
							</Col>
						</Row>
					</div>
					<div className="header-background-outer d-none d-sm-block d-md-none">
						<Row className="header-inner pt-2 pb-3">
							<Col xs={3} className="header-logo">
								<Link to="/">
									<img className="logo-365" src="/images/365_Logo.png" alt="Mix365 Logo" />
								</Link>
							</Col>
							<Col xs={6}>
								<AudioPlayer mobile={true} />
							</Col>
							<Col xs={3} className="text-vright header-menu-bar" onClick={mobileMenu}>
								<FontAwesomeIcon icon="bars" className="header-menu-bar-icon" />
							</Col>
						</Row>
					</div>

					<div className="header-background-outer d-block d-sm-none">
						<Row className="header-inner pt-2 pb-3">
							<Col xs={6} className="header-logo">
								<Link to="/">
									<img className="logo-365" src="/images/365_Logo.png" alt="Mix365 Logo" />
								</Link>
							</Col>
							
							<Col className="text-vright header-menu-bar" onClick={mobileMenu}>
								<FontAwesomeIcon icon="bars" className="header-menu-bar-icon" />
							</Col>
							<Col xs={12}>
								<AudioPlayer mobile={true} />
							</Col>
						</Row>
					</div>
				
					{mobile &&
						<div className="mobile-menu">
							<div className="header-background-outer d-none d-sm-block d-md-none">
								<Row className="header-inner pt-2 pb-3" style={{height:82}}>
									<Col xs={3} className="header-logo">
										<Link to="/">
											<img className="logo-365" src="/images/365_Logo.png" alt="Mix365 Logo" />
										</Link>
									</Col>
									<Col className="text-vright header-menu-bar" onClick={mobileMenu}>
										<FontAwesomeIcon icon="bars" className="header-menu-bar-icon" />
									</Col>
								</Row>
							</div>
							<div className="header-background-outer d-block d-sm-none">
								<Row className="header-inner pt-2 pb-3" style={{height:72}}>
									<Col xs={6} className="header-logo">
										<Link to="/">
											<img className="logo-365" src="/images/365_Logo.png" alt="Mix365 Logo" />
										</Link>
									</Col>
									<Col className="text-vright header-menu-bar" onClick={mobileMenu}>
										<FontAwesomeIcon icon="bars" className="header-menu-bar-icon" />
									</Col>
								</Row>
							</div>
							<Row>
								<Col xs={12}>
									<ul className="mobile-menu-ul">
										<li><Link to="/" className={page==='index'?"header-menu-active":""} onClick={mobileMenu}>HOME</Link></li>

										<li><Link to="" onClick={()=>setMenu(0)}>MIX365<span className="float-right pr-3"><FontAwesomeIcon icon={index===0?"caret-up":"caret-down"} /></span></Link></li>
										{index===0&&
											<>
												<li><Link to="/about" className={subPage==='about'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>About Us</Link></li>
												<li><Link to="/privacy" className={subPage==='privacy'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Privacy Policy</Link></li>

												<li><Link to="/event/event-name" className={subPage==='events'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Event Name</Link></li>
												<li><Link to="/mix365djs" className={subPage==='mix365djs'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Mix365 DJ's</Link></li>
												<li><Link to="/previous-sets" className={subPage==='previous-sets'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Previous Sets</Link></li>
												<li><Link to="/listen" className={subPage==='listen'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Ways to Listen</Link></li>
											</>
										}
										
										<li><Link to="" onClick={()=>setMenu(1)}>SCHEDULE<span className="float-right pr-3"><FontAwesomeIcon icon={index===1?"caret-up":"caret-down"} /></span></Link></li>
										{index===1&&
											<>
												<li><Link to="/hyper/schedule" className={subPage==='hyper/schedule'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Mix365 Hyper</Link></li>
												<li><Link to="/evolution/schedule" className={subPage==='evolution/schedule'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Mix365 Evolution</Link></li>
											</>
										}

										<li><Link to="" onClick={()=>setMenu(2)}>WATCH LIVE<span className="float-right pr-3"><FontAwesomeIcon icon={index===2?"caret-up":"caret-down"} /></span></Link></li>
										{index===2&&
											<>
												<li><Link to="/hyper" className={subPage==='hyper'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Hyper Live</Link></li>
												<li><Link to="/evolution" className={subPage==='evolution'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Evolution Live</Link></li>
												<li><a href="/mchat" style={{paddingLeft: 40}}>Mobile Chat</a></li>
											</>
										}

										<li><Link to="" onClick={() => setMenu(3)}>RADIO

										  <span className="float-right pr-3"><FontAwesomeIcon icon={index===3 ? "caret-up" : "caret-down"} /></span>

										</Link></li>



										{index===3 &&

										  <>

										    <li><Link to="/radio/house" className={subPage==='house' ? "header-menu-active" : ""} style={{paddingLeft: 40}} onClick={mobileMenu}>

										      <FontAwesomeIcon icon="music" />&nbsp;&nbsp;House

										    </Link></li>

										    <li><Link to="/radio/trance" className={subPage==='trance' ? "header-menu-active" : ""} style={{paddingLeft: 40}} onClick={mobileMenu}>

										      <FontAwesomeIcon icon="record-vinyl" />&nbsp;&nbsp;Trance

										    </Link></li>

										    <li><Link to="/radio/techno" className={subPage==='techno' ? "header-menu-active" : ""} style={{paddingLeft: 40}} onClick={mobileMenu}>

										      <FontAwesomeIcon icon="headphones" />&nbsp;&nbsp;Techno

										    </Link></li>

										    <li><Link to="/radio/oldskool" className={subPage==='oldskool' ? "header-menu-active" : ""} style={{paddingLeft: 40}} onClick={mobileMenu}>

										      <FontAwesomeIcon icon="compact-disc" />&nbsp;&nbsp;Old Skool

										    </Link></li>

										  </>

										}




										
										<li><Link to="" onClick={()=>setMenu(4)}>CONTACT<span className="float-right pr-3"><FontAwesomeIcon icon={index===3?"caret-up":"caret-down"} /></span></Link></li>
										{index===3&&
											<>
												<li><Link to="/contact" className={subPage==='contact'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Contact Us</Link></li>
												<li><Link to="/apply" className={subPage==='apply'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Apply to Dj</Link></li>
												<li><Link to="/advertise" className={subPage==='advertise'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Advertise</Link></li>
											</>
										}
										
										<li><Link to="/shop" className={page==='shop'?"header-menu-active":""} onClick={mobileMenu}>SHOP</Link></li>

										{user.admin?.mod_access &&
											<>
												<li><Link to="" onClick={()=>setMenu(4)}>DJ AREA<span className="float-right pr-3"><FontAwesomeIcon icon={index===4?"caret-up":"caret-down"} /></span></Link></li>
												{index===4&&
													<>
														<li><Link to="/djarea" className={subPage==='djarea'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>DJ Area</Link></li>
														<li><Link to="/djarea/members" className={subPage==='djarea/members'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Members</Link></li>
														<li><Link to="/djarea/connection" className={subPage==='djarea/connection'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Connection Details</Link></li>
														<li><Link to="/djarea/socials" className={subPage==='djarea/socials'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Socials & Posters</Link></li>
														<li><Link to="/djarea/files" className={subPage==='djarea/files'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Drops, Jingles & Files</Link></li>
														<li><Link to="/djarea/logs" className={subPage==='djarea/logs'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Schedule Logs</Link></li>
													</>
												}
											</>
										}

										{user.admin?.admin_access &&
											<>
												<li><Link to="#" onClick={()=>setMenu(5)}>ADMIN AREA<span className="float-right pr-3"><FontAwesomeIcon icon={index===5?"caret-up":"caret-down"} /></span></Link></li>
												{index===5&&
													<>
														<li><Link to="/admin" className={subPage==='admin'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Admin</Link></li>
														<li><Link to="/admin/djaccounts" className={subPage==='admin/djaccounts'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>DJ Accounts</Link></li>
														<li><Link to="/admin/events" className={subPage==='admin/events'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Events</Link></li>
														<li><Link to="/admin/weekly" className={subPage==='admin/weekly'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Weekly Sets</Link></li>
														<li><Link to="/admin/publish" className={subPage==='admin/publish'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Publish Sets</Link></li>
														<li><Link to="/admin/seo" className={subPage==='admin/seo'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>SEO</Link></li>
													</>
												}
											</>
										}

										
										{user.access.verified ?
											<>
												<li><Link to="#" onClick={()=>setMenu(6)}>MY PROFILE<span className="float-right pr-3"><FontAwesomeIcon icon={index===6?"caret-up":"caret-down"} /></span></Link></li>
												{index===6&&
													<>
														<li><Link to={`/${user.user.username.toLowerCase().replaceAll(' ','_')}`} className={subPage==='profile'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>{user.user.title?user.user.title:user.user.username}</Link></li>
														{/*<li><Link to={`/notifications`} className={subPage==='notifications'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Notifications</Link></li>*/}
														<li><Link to={`/settings/${user.user.username.toLowerCase().replaceAll(' ','_')}`} className={subPage==='settings'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Account settings</Link></li>
														<li><Link to={`/logout`} className={subPage==='logout'?"header-menu-active":""} style={{paddingLeft: 40}} onClick={mobileMenu}>Logout</Link></li>
													</>
												}
											</>
										:
											<>
												<li><Link to="/login" onClick={mobileMenu}>LOGIN</Link></li>
												<li><Link to="/register" onClick={mobileMenu}>REGISTER</Link></li>
											</>
										}
										<li><Link to="#" onClick={()=>donation()}>DONATE</Link></li>
									</ul>
								</Col>
							</Row>
						</div>
					}		
				</header>
			}
		</>
	);
}
